import {
  CANCEL_PIN_CODE_WINDOW_BY_USER_CODE_ERROR,
  CANCEL_CONFIRM_CERT_WINDOW_BY_USER_CODE_ERROR,
} from "../constants";

export const hasCancelPluginWindowByUser = (error: string) =>
  error.includes(CANCEL_PIN_CODE_WINDOW_BY_USER_CODE_ERROR) ||
  error.includes(CANCEL_CONFIRM_CERT_WINDOW_BY_USER_CODE_ERROR);
